import request from '@/utils/request'

const BaseUrl = '/resource'

// 根据人员查询占用详情
export function getPersonAccount(id,params) {
  return request({
    url: `/details/findByPerson/${id}`,
    method: 'post',
    params
  })
}

// 资源申请新增或修改
export function addApplication(data) {
  return request({
    url: `${BaseUrl}/save`,
    method: 'post',
    data
  })
}

export function updateApplication(data) {
  return request({
    url: `${BaseUrl}/update`,
    method: 'put',
    data
  })
}

// 资源申请删除
export function deleteApplicationById(id) {
  return request({
    url: `${BaseUrl}/delete/${id}`,
    method: 'delete',
  })
}

// 资源申请详情
export function getResourceDetail(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}
// 资源释放新增
export function addRelease(data) {
  return request({
    url: `/resourceRelease/save`,
    method: 'post',
    data
  })
}

export function updateRelease(data) {
  return request({
    url: `${BaseUrl}/update`,
    method: 'put',
    data
  })
}
// 根据人员ID查询占用详情(用于释放)
export function getPersonRelease(id,params) {
  return request({
    url: `/details/forRelease/${id}`,
    method: 'post',
    params
  })
}
// 资源释放详情
export function getReleaseDetail(id) {
  return request({
    url: `/resourceRelease/${id}`,
    method: 'get',
  })
}

// 根据人员ID和项目ID查出项目角色
export function getProjectRoles(id,params) {
  return request({
    url: `/details/getProjectRoles/${id}`,
    method: 'post',
    params
  })
}